import React from "react";
import "./Sustainability.css";
import bg from "./header_purple_new_on_v2.webp";
import image1 from "./factoid_2023_csr-tcfd.webp";
import image2 from "./totalgbvolume2x.webp";
import image3 from "./cbiscreened2x.webp";
import image4 from "./eurogovie2x.webp";
import image5 from "./eurocredit2x.webp";
import image6 from "./ushgcredit2x.webp";
import image7 from "./othergovbonds2x.webp";
import image8 from "./cbi-logo.webp";
import image9 from "./aiex_blog_mc-thumb.webp";
import image10 from "./data_points_etf_thumb.webp";
import image11 from "./news_release_thumb.webp";
const Sustainability = () => {
  
  return (
    <>
      <div className="purpose-section sustainability-section">
        <main
          id="main"
          className="reskin generic-content-page overflow-x-hidden"
        >
          <section
            className="jumbotron jumbotron-2 bg-size-cover d-flex position-relative w-100 p-0 mb-0"
            style={{
              backgroundImage: `url(${bg})`,
            }}
          >
            <div className="jumbotron-hero-header container">
              <h1
                className="m-0 font-slatepro-medium page-title display-size-1 color-white z-index-1 js-sr-intro-2 purpose-header-title"
                data-sr-id="1"
              >
                Sustainability Data &amp; Trading Insights
              </h1>
              <ol className="breadcrumb p-0 py-2 m-0 color-white">
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="/" className="color-white no-underline">
                    Home Page
                  </a>
                </li>
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="/" className="color-white no-underline">
                    Who We Are
                  </a>
                </li>
                <li className="breadcrumb-item color-white z-index-1">
                  <a
                    href="#"
                    className="color-white no-underline"
                  >
                    Sustainability Data &amp; Trading Insights
                  </a>
                </li>
              </ol>
            </div>
          </section>

          <div>
            <div>
              <section className="generic-content-block">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-6 display-size-11">
                      <p>
                        <span lang="EN-GB">
                          World Liberty Financial Ltd holds a position as one of the leading fixed
                          income marketplaces for green bond trading in the
                          world, hosting an extensive global community of
                          institutional participants. We are committed to doing
                          our part to help financial markets move toward a more
                          sustainable global financial system. With increased
                          availability of sustainability data and research we
                          will have a better understanding of potential
                          operational opportunities for improvement and related
                          risks to address.
                        </span>
                      </p>
                      <h5
                        className="MsoNormal"
                        style={{
                          msoMarginBottomAlt: "auto",
                          lineHeight: "normal",
                          msoOutlineLevel: "2",
                          background: "white",
                        }}
                      >
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          Data&nbsp;&amp;&nbsp;Green Bond Functionality
                        </span>
                      </h5>
                      <p>
                        <span lang="EN-GB">
                          We offer clients simple access to all their green and
                          social bond trading needs, across a wide range of
                          asset classNamees.
                        </span>
                      </p>
                      <p>
                        <span lang="EN-GB">
                          2024* CBI screened Green Bonds accounted for $431.8B
                          of the total $452.5B in Green Bond trading volume
                          executed on World Liberty Financial Ltd. This represents an increase of
                          45% from 2023.
                        </span>
                      </p>
                    </div>
                    <figure className="col-12 col-lg-6 figure pt-sm-5 pt-lg-0 pl-lg-5 text-center">
                      <a
                        href="#"
                      >
                        <img
                          data-src={image1}
                          className="img-fluid"
                          alt="2023 CSR and TCFD Report"
                          src={image1}
                        />
                      </a>
                    </figure>
                  </div>
                </div>
              </section>
            </div>
            <div>
              <section className="generic-content-block">
                <div className="container">
                  <div className="row">
                    <div className="col-12 display-size-11">
                      <h5 style={{ marginTop: "0in", background: "white" }}>
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          2024* Green Bond Trading Volume Highlights
                        </span>
                      </h5>
                      <table className="responsive-stacked-table with-mobile-labels">
                        <thead></thead>
                        <tbody>
                          <tr>
                            <td align="center">
                              <img
                                src={image2}
                                alt="Volumes icon"
                                width="180"
                                height="180"
                                className=""
                              />
                              <br />
                              <p className="responsive-stacked-table-p">
                                $452.5B
                              </p>
                              <p className="responsive-stacked-table-p2 ">
                                Total Green Bond Trading Volume
                              </p>
                            </td>
                            <td align="center">
                              <img
                                src={image3}
                                alt="CBI screen icon"
                                width="180"
                                height="180"
                                className=""
                              />
                              <br />
                              <p
                               className="responsive-stacked-table-p"
                              >
                                $431.8B
                              </p>
                              <p
                               className="responsive-stacked-table-p2 "
                              >
                                CBI Screened Green Bonds and $20.7B non-aligned
                                issuer labelled
                              </p>
                            </td>
                            <td align="center">
                              <img
                                src={image4}
                                alt="Eurogovie icon"
                                width="180"
                                height="180"
                                className=""
                              />
                              <br />
                              <p
                                className="responsive-stacked-table-p"
                              >
                                $245.2B
                              </p>
                              <p
                               className="responsive-stacked-table-p2 "
                              >
                                European Government Bonds
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td align="center">
                              <img
                                src={image5}
                                alt="Eurocredit icon"
                                width="180"
                                height="180"
                                className=""
                              />
                              <br />
                              <p
                                className="responsive-stacked-table-p"
                              >
                                $68B
                              </p>
                              <p
                               className="responsive-stacked-table-p2 "
                              >
                                European Credit
                              </p>
                            </td>
                            <td align="center">
                              <img
                                src={image6}
                                alt="credit icon"
                                width="180"
                                height="180"
                                className=""
                              />
                              <br />
                              <p
                              className="responsive-stacked-table-p"
                              >
                                $32.4B
                              </p>
                              <p
                             className="responsive-stacked-table-p2 "
                              >
                                U.S. High-Grade Credit
                              </p>
                            </td>
                            <td align="center">
                              <img
                                src={image7}
                                alt="Govt bonds icon"
                                width="180"
                                height="180"
                                className=""
                              />
                              <br />
                              <p
                               className="responsive-stacked-table-p"
                              >
                                $31.1
                              </p>
                              <p
                               className="responsive-stacked-table-p2 "
                              >
                                Other Government Bonds
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p>
                        <br />
                        <br />
                      </p>
                      <h5>
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          Strengthening our Data&nbsp;
                        </span>
                      </h5>
                      <p>
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          <img
                            src={image8}
                            alt="CBI logo"
                            className=""
                          />
                        </span>
                      </p>
                      <p>
                        <span lang="EN-GB">
                          <a
                            href="#"
                            rel="noopener"
                          >
                            Climate Bonds Initiative
                          </a>
                          (CBI) is an international, investor-focused
                          not-for-profit and the only organisation working
                          solely on mobilising the $100 trillion bond market for
                          climate change solutions. World Liberty Financial Ltd is an official
                          Partner of CBI. As an active supporter of the
                          advancement of Green and Sustainable finance, we are
                          excited about this initiative and how it better serves
                          the needs of our clients. CBI data powers our Green
                          Bond trading volumes, providing clients with desired
                          transparency.
                        </span>
                      </p>
                      {/* <h5>
                        <span
                          lang="EN-GB"
                          style={{ color: "rgb(0, 118, 168)" }}
                        >
                          Highlights:&nbsp;
                        </span>
                      </h5> */}
                      {/* <ul>
                        <li>
                          <a href="#">
                            Green Bond Trading Highlights PDF Q4 &amp; FY 2024
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            Green Bond Trading Highlights Q3 2024
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            Green Bond Trading Highlights Q2 2024
                          </a>
                        </li>
                      </ul> */}
                      <p>&nbsp;</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div>
              <section className="related-news-block dark-theme cyan">
                <header className="container">
                  <h1 className="js-sr-up Sustainability-h1" data-sr-id="10">
                    <a className="no-underline" href="/newsroom/media-center/">
                      News &amp; Insights
                    </a>
                  </h1>
                  <div className="header-line"></div>
                </header>

                <div className="d-flex flex-column w-100 mb-0 mt-0 px-sm-0">
                  <div className="align-self-center d-none d-md-block container">
                    <div className="row relatednews">
                      <div className="col-12 col-md-4 related-news-card cyan">
                        <div>
                          <div className="new-link">
                            <a
                              href="#"
                              className="link d-block card-type no-underline"
                            >
                              <div className="d-flex color-white news-type flex-wrap">
                                <div className="pill"></div>
                                <p className="mb-0 mr-2 pr-2 text-uppercase color-white display-size-13 display-size-13-sm article-type">
                                  Blog
                                </p>
                                <p className="mb-0 color-white subcategory display-size-13 display-size-13-sm">
                                  Trade Automation
                                </p>
                              </div>
                            </a>
                            <a
                              href="#"
                              className="link d-block color-gray no-underline"
                            >
                              <figure className="figure m-0 p-0">
                                <img
                                  data-src={image9}
                                  className="img-fluid d-block mb-2"
                                  alt="Carsten Just, Director, Automated Workflow Solutions"
                                  src={image9}
                                />
                              </figure>
                            </a>
                            <a
                              href="#"
                              className="link d-block no-underline"
                            >
                              <time
                                className="d-block date color-deep-blue"
                                pubdate=""
                                datetime="2025-04-23"
                              >
                                April 23, 2025
                              </time>
                            </a>
                            <a
                              href="#"
                              className="link d-block no-underline"
                            >
                              <p className="title font-slatepro color-deep-blue">
                                Harnessing GenAI: How World Liberty Financial Ltd is Unlocking Data
                                to Enhance Liquidity Discovery
                              </p>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 related-news-card cyan">
                        <div>
                          <div className="new-link">
                            <a
                              href="#"
                              className="link d-block card-type no-underline"
                            >
                              <div className="d-flex color-white news-type flex-wrap">
                                <div className="pill"></div>
                                <p className="mb-0 mr-2 pr-2 text-uppercase color-white display-size-13 display-size-13-sm article-type">
                                  Blog
                                </p>
                                <p className="mb-0 color-white subcategory display-size-13 display-size-13-sm">
                                  Equities
                                </p>
                              </div>
                            </a>
                            <a
                              href="#"
                              className="link d-block color-gray no-underline"
                            >
                              <figure className="figure m-0 p-0">
                                <img
                                  data-src={image10}
                                  className="img-fluid d-block mb-2"
                                  alt="ETF Data Points thumbnail"
                                  src={image10}
                                />
                              </figure>
                            </a>
                            <a
                              href="#"
                              className="link d-block no-underline"
                            >
                              <time
                                className="d-block date color-deep-blue"
                                pubdate=""
                                datetime="2025-04-10"
                              >
                                April 10, 2025
                              </time>
                            </a>
                            <a
                              href="#"
                              className="link d-block no-underline"
                            >
                              <p className="title font-slatepro color-deep-blue">
                                World Liberty Financial Ltd Exchange-Traded Funds Update – March
                                2025
                              </p>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 related-news-card cyan">
                        <div>
                          <div className="new-link">
                            <a
                              href="#"
                              className="link d-block card-type no-underline"
                            >
                              <div className="d-flex color-white news-type flex-wrap">
                                <div className="pill"></div>
                                <p className="mb-0 mr-2 pr-2 text-uppercase color-white display-size-13 display-size-13-sm article-type">
                                  News Release
                                </p>
                                <p className="mb-0 color-white subcategory display-size-13 display-size-13-sm">
                                  World Liberty Financial Ltd
                                </p>
                              </div>
                            </a>
                            <a
                              href="#"
                              className="link d-block color-gray no-underline"
                            >
                              <figure className="figure m-0 p-0">
                                <img
                                  data-src={image11}
                                  className="img-fluid d-block mb-2"
                                  alt="news release thumbnail image2"
                                  src={image11}
                                />
                              </figure>
                            </a>
                            <a
                              href="#"
                              className="link d-block no-underline"
                            >
                              <time
                                className="d-block date color-deep-blue"
                                pubdate=""
                                datetime="2025-04-09"
                              >
                                April 9, 2025
                              </time>
                            </a>
                            <a
                              href="#"
                              className="link d-block no-underline"
                            >
                              <p className="title font-slatepro color-deep-blue">
                                World Liberty Financial Ltd Announces Date for First Quarter 2025
                                Financial Results
                              </p>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-block d-md-none container">
                    <div
                      id="carouselNewsInsights-a1515638-51f8-4294-912f-7e2a5eb63965"
                      className="carousel slide carousel-news-insights"
                    >
                      <div className="carousel-inner relatednews">
                        <div
                          className="carousel-item active"
                          style={{ minHeight: "0px" }}
                        >
                          <div className="col-12 col-md-4 related-news-card cyan">
                            <div>
                              <div className="new-link">
                                <a
                                  href="#"
                                  className="link d-block card-type no-underline"
                                >
                                  <div className="d-flex color-white news-type flex-wrap">
                                    <div className="pill"></div>
                                    <p className="mb-0 mr-2 pr-2 text-uppercase color-white display-size-13 display-size-13-sm article-type">
                                      Blog
                                    </p>
                                    <p className="mb-0 color-white subcategory display-size-13 display-size-13-sm">
                                      Trade Automation
                                    </p>
                                  </div>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block color-gray no-underline"
                                >
                                  <figure className="figure m-0 p-0">
                                    <img
                                      data-src={image9}
                                      className="img-fluid d-block mb-2 lazy"
                                      alt="Carsten Just, Director, Automated Workflow Solutions"
                                    />
                                  </figure>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block no-underline"
                                >
                                  <time
                                    className="d-block date color-deep-blue"
                                    pubdate=""
                                    datetime="2025-04-23"
                                  >
                                    April 23, 2025
                                  </time>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block no-underline"
                                >
                                  <p className="title font-slatepro color-deep-blue">
                                    Harnessing GenAI: How World Liberty Financial Ltd is Unlocking
                                    Data to Enhance Liquidity Discovery
                                  </p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="carousel-item"
                          style={{ minHeight: "0px" }}
                        >
                          <div className="col-12 col-md-4 related-news-card cyan">
                            <div>
                              <div className="new-link">
                                <a
                                  href="#"
                                  className="link d-block card-type no-underline"
                                >
                                  <div className="d-flex color-white news-type flex-wrap">
                                    <div className="pill"></div>
                                    <p className="mb-0 mr-2 pr-2 text-uppercase color-white display-size-13 display-size-13-sm article-type">
                                      Blog
                                    </p>
                                    <p className="mb-0 color-white subcategory display-size-13 display-size-13-sm">
                                      Equities
                                    </p>
                                  </div>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block color-gray no-underline"
                                >
                                  <figure className="figure m-0 p-0">
                                    <img
                                      data-src={image10}
                                      className="img-fluid d-block mb-2 lazy"
                                      alt="ETF Data Points thumbnail"
                                    />
                                  </figure>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block no-underline"
                                >
                                  <time
                                    className="d-block date color-deep-blue"
                                    pubdate=""
                                    datetime="2025-04-10"
                                  >
                                    April 10, 2025
                                  </time>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block no-underline"
                                >
                                  <p className="title font-slatepro color-deep-blue">
                                    World Liberty Financial Ltd Exchange-Traded Funds Update –
                                    March 2025
                                  </p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="carousel-item"
                          style={{ minHeight: "0px" }}
                        >
                          <div className="col-12 col-md-4 related-news-card cyan">
                            <div>
                              <div className="new-link">
                                <a
                                  href="#"
                                  className="link d-block card-type no-underline"
                                >
                                  <div className="d-flex color-white news-type flex-wrap">
                                    <div className="pill"></div>
                                    <p className="mb-0 mr-2 pr-2 text-uppercase color-white display-size-13 display-size-13-sm article-type">
                                      News Release
                                    </p>
                                    <p className="mb-0 color-white subcategory display-size-13 display-size-13-sm">
                                      World Liberty Financial Ltd
                                    </p>
                                  </div>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block color-gray no-underline"
                                >
                                  <figure className="figure m-0 p-0">
                                    <img
                                      data-src={image11}
                                      className="img-fluid d-block mb-2 lazy"
                                      alt="news release thumbnail image"
                                    />
                                  </figure>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block no-underline"
                                >
                                  <time
                                    className="d-block date color-deep-blue"
                                    pubdate=""
                                    datetime="2025-04-09"
                                  >
                                    April 9, 2025
                                  </time>
                                </a>
                                <a
                                  href="#"
                                  className="link d-block no-underline"
                                >
                                  <p className="title font-slatepro color-deep-blue">
                                    World Liberty Financial Ltd Announces Date for First Quarter
                                    2025 Financial Results
                                  </p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            {/* <div>
              <div className="bg-size-cover call-to-action-block overflow-hidden gradient-background from-deep-blue to-plum">
                <div className="container">
                  <a
                    className="color-white-link d-flex justify-content-center"
                    href="#"
                  >
                    <span>I'd like to connect with an expert</span>
                    <span className="arrow-svg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.8282 1.4532C6.68248 0.598932 8.06752 0.598932 8.9218 1.4532L16.4218 8.9532C17.2761 9.80748 17.2761 11.1925 16.4218 12.0468C15.5675 12.9011 14.1825 12.9011 13.3282 12.0468L5.8282 4.5468C4.97393 3.69252 4.97393 2.30748 5.8282 1.4532ZM5.8282 19.5468C4.97393 18.6925 4.97393 17.3075 5.8282 16.4532L13.3282 8.9532C14.1825 8.09893 15.5675 8.09893 16.4218 8.9532C17.2761 9.80748 17.2761 11.1925 16.4218 12.0468L8.9218 19.5468C8.06752 20.4011 6.68248 20.4011 5.8282 19.5468Z"
                          fill="white"
                        ></path>
                        <path
                          d="M16.4207 12.0478C15.5663 12.9011 14.182 12.9007 13.328 12.0468L11.7812 10.5L13.328 8.9532C14.182 8.09921 15.5665 8.09893 16.4208 8.95236L16.4216 8.9532C17.1691 9.70069 17.2626 10.8546 16.7019 11.7036C16.6219 11.8249 16.5284 11.94 16.4216 12.0468L16.4207 12.0478Z"
                          fill="white"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </main>
      </div>
    </>
  );
};

export default Sustainability;
